import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  activeCourseAdapter,
  AdminCourseListState,
  inactiveCourseAdapter,
} from "../reducers/admin/course-admin.reducer";
import {
  PackageListState,
  packagesAdapter,
} from "../reducers/packages/packages.reducer";

export const adminSelector =
  createFeatureSelector<AdminCourseListState>("course");
export const packageSelector =
  createFeatureSelector<PackageListState>("packages");

export const adminActiveCourseSelectors = activeCourseAdapter.getSelectors(
  createSelector(adminSelector, (state) => state.active.subscriptions),
);
export const adminInactiveCourseSelectors = inactiveCourseAdapter.getSelectors(
  createSelector(adminSelector, (state) => state.inactive.subscriptions),
);

export const adminAllCourseSelectors = createSelector(
  adminActiveCourseSelectors.selectAll,
  adminInactiveCourseSelectors.selectAll,
  (activeCourses, inactiveCourses) => [...activeCourses, ...inactiveCourses],
);

export const adminPackagesSelector = packagesAdapter.getSelectors(
  createSelector(packageSelector, (state) => state),
);
